import React, { useRef, useEffect, useState } from 'react';
import CarouselSlide from './CarouselSlide';
import BackgroundImageCurve from "./BackgroundImageCurve";
import { makeStyles } from '@material-ui/core/styles';
import { Swiper, SwiperSlide } from "swiper/react";

// import Swiper core and required modules
import SwiperCore, {
  Pagination, 
  Navigation,
  Autoplay,
  Keyboard,
  EffectFade,
} from "swiper/core";
import { LargeBusiness } from '../../Constants';
import { primaryText, white } from '../../utils/CssGlobalVariables';

// install Swiper modules
SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade, Keyboard]);

function EirResponsiveCarousel(props) {

  const [carouselSpecs] = useState(props.carouselDetails.carosuselSpecs);
  const [slides] = useState(props.carouselDetails.slideContent)
  const [isCDT,setIsCDT] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);
  const playButton = useRef(null);
  const pauseButton = useRef(null);
  const userPausedRef = useRef(false);
  const mouseHoverRef = useRef(false);
  const swiperContainerRef = useRef(null);
  
  const playPauseToggle = () => {
    const swiper = swiperRef.current;
    if (!swiper) return;

    if (pauseButton.current.style.display === 'none') {
      playButton.current.style.display = 'none';
      playButton.current.tabIndex = -1;
      pauseButton.current.style.display = 'flex';
      pauseButton.current.tabIndex = 0;
      swiperRef.current.autoplay.start();
      userPausedRef.current = false;
      if (mouseHoverRef.current && swiperRef.current.autoplay.running) {
        swiperRef.current.autoplay.stop();
      }
    } else {
      pauseButton.current.style.display = 'none';
      pauseButton.current.tabIndex = -1;
      playButton.current.style.display = 'flex';
      playButton.current.tabIndex = 0;
      swiperRef.current.autoplay.stop();
      userPausedRef.current = true;
    }
    updateSlidesTabIndex(swiper);
  };

  const handleMouseEnter = () => {
    mouseHoverRef.current = true;
    if (swiperRef.current && swiperRef.current.autoplay.running) {
      swiperRef.current.autoplay.stop();  // pause autoplay on mouse enter
    }
  };
  
  const handleMouseLeave = () => {
    mouseHoverRef.current = false;
    if (swiperRef.current && !swiperRef.current.autoplay.running && !userPausedRef.current) {
      swiperRef.current.autoplay.start(); // resume autoplay on mouse leave
    }
  };

  const handleTouchStart = () => {
    mouseHoverRef.current = true;
    if (swiperRef.current && swiperRef.current.autoplay.running) {
      swiperRef.current.autoplay.stop();  // pause autoplay on touch start
    }
  };
  
  const handleTouchEnd = () => {
    mouseHoverRef.current = false;
    if (swiperRef.current && !swiperRef.current.autoplay.running && !userPausedRef.current) {
      swiperRef.current.autoplay.start(); // resume autoplay on touch end
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault(); // prevent page scroll on space
      playPauseToggle();
    }
  };
  
  useEffect(() => {
    const cdtContent=slides.filter(content => content.countdownTimer!=undefined)
    // if any changes required based on CDT's presence 
    // setIsCDT(
    //   cdtContent.length == 0 ? false : true
    // )
    
   //Swiper Navigators
   const nextNav = document.querySelector(".swiper-button-next");
   const prevNav = document.querySelector(".swiper-button-prev");
   const pagination = document.querySelectorAll(".swiper-pagination > span");

   //Array of all Swiper Navigators
   const allNavigators = [
     nextNav,
     prevNav,
     ...Array.from(pagination).map((dot) => dot),
   ];

   const setTabIndex = (element) => {
     if(element!= null){
      element.setAttribute("tabindex", 0);
      element.setAttribute("role", "button");
     }
   
   };
   const onArrowFocus = (element) => {
   
    element.addEventListener("keypress", (e) => {
      if (e.key == "Enter" || e.keyCode == 13) {
        element.click();
      }
    });
   };

   //Setting JS Swiper Navigators
   allNavigators.map((element) => setTabIndex(element));
   allNavigators.forEach((element) =>{
    if(element!= null){
      element.addEventListener("focus", onArrowFocus(element))
     } 
   }
   
   );

  }, [])


  //animation timeout is not working
  const animationTimeout = parseInt(carouselSpecs.AnimationTimeout!=undefined? carouselSpecs.AnimationTimeout:"1000");
 
  const carouselProps =  {
    animation: carouselSpecs.Animation!=undefined?carouselSpecs.Animation:"slide",
    animationTimeout: !isNaN(animationTimeout)?animationTimeout:1000,
    autoPlay: carouselSpecs.AutoPlay!=undefined?carouselSpecs.AutoPlay=="true":true,
    loopInterval: carouselSpecs.LoopInterval!=undefined?carouselSpecs.LoopInterval:5000,
    indicators: {
      enabled: slides.length>1 ? true : false,
      arrows: {
        style: {
          color:
          carouselSpecs.navigator.navigatorArrowColor !== undefined
          ? carouselSpecs.navigator.navigatorArrowColor
          : primaryText
        }
      },
      pagination:{
          style : {
            background: carouselSpecs.navigator.navigatorPaginationDotColor !== undefined
            ? carouselSpecs.navigator.navigatorPaginationDotColor
            : white
          },
          pseudoActive:
          {
            background: carouselSpecs.navigator.navigatorPaginationDotActiveColor !== undefined
            ? carouselSpecs.navigator.navigatorPaginationDotActiveColor
            : white
          }
      }
    }
  }

  const animationEffects = {
    fadeEffect:{
      crossFade: carouselProps.animation=="fade"?true:false
    },
    slide:{
      
    }
  }
  

  const carouselStyle = makeStyles({
      root: {
          '& .swiper-button-next::after': carouselProps.indicators.arrows.style,
          '& .swiper-button-prev::after': carouselProps.indicators.arrows.style,
          '& .swiper-pagination-bullet': carouselProps.indicators.pagination.style,
          '& .swiper-pagination-bullet:focus': { opacity: 0.7 },
          '& .swiper-pagination-bullet': {
            ...carouselProps.indicators.pagination.style,
            margin: '0 5px !important',
            width:'14px',
            height:'14px',
            background:'transparent',
            opacity:1,
            border:`1px solid ${carouselProps.indicators.pagination.style.background}`
            },
          '& .swiper-pagination-bullet-active': {
              ...carouselProps.indicators.pagination.pseudoActive,
              borderRadius: '1000px',
              width:'34.18px',
              height:'18px',
              border:`1px solid ${carouselProps.indicators.pagination.pseudoActive.background} !important`
          }
      }
  });

  //large business site carousel
  const lbcarouselStyle = makeStyles({
    root:{
      "& .swiper-button-next::after":carouselProps.indicators.arrows.style,
      "& .swiper-button-prev::after":carouselProps.indicators.arrows.style,
      "& .swiper-pagination-bullet":carouselProps.indicators.pagination.style,
      "& .swiper-pagination-bullet:focus":{opacity:0.7},
      "& .swiper-pagination-bullet-active":carouselProps.indicators.pagination.pseudoActive,
    }

  })

  const chooseStyle = LargeBusiness.isLBSite ? lbcarouselStyle : carouselStyle;
  const lbConatiner = LargeBusiness.isLBSite ? "lb-responsive-carousel-container" : ""

  const handleRemoveCDT = (e) => {
    const triggerBtn = e.currentTarget;
    // const previouslyFocusedElement = document.activeElement;
    
    const slide = triggerBtn.closest('.swiper-slide');
    if (!slide) {
      // Fallback: not inside a slide, bail gracefully
      return;
    }
    const realIndex = slide.getAttribute('data-swiper-slide-index') || swiperRef.current.realIndex;
    const swiperContainer = slide.closest('.swiper-wrapper');
    
    
  // FIRST attempt: loop=true case (using data-swiper-slide-index)
  let targets = swiperContainer.querySelectorAll(
    `.swiper-slide[data-swiper-slide-index="${realIndex}"] .carousel-description-countdowntimer`
  );

  // SECOND attempt: loop=false case (fallback to active slide)
  if (!targets.length) {
    targets = swiperContainer.querySelectorAll(
      `.swiper-slide-active .carousel-description-countdowntimer`
    );
  }

  targets
    .forEach(el => {
      el.classList.add('hidden-cdt');
      el.setAttribute('aria-hidden', 'true');
    });

    // const slidesToUpdate = document.querySelectorAll(`.swiper-slide[data-swiper-slide-index="${slideRealIndex}"]`);
    // slidesToUpdate.forEach(slide => {
      // const cdtElement = slide.querySelector('.carousel-description-countdowntimer');
      // if (cdtElement) {
      //   cdtElement.remove();
      //   cdtElement.classList.add('hidden-cdt');
      //   // cdtElement.style.display = 'none';
      //   cdtElement.setAttribute('aria-hidden', 'true');
      // }
    // });
    // previouslyFocusedElement.focus();
  };

  const updateSlidesTabIndex = (swiper) => {
    swiper.slides && swiper.slides.length && swiper.slides.forEach(slideEl => {
      const ctaDiv = slideEl.querySelector('.eir-button-cta');
      const ctaAnchor = slideEl.querySelector('.eir-button-cta a');
      
        slideEl.setAttribute('tabindex', '0'); // Active slide is focusable
        slideEl.setAttribute('aria-hidden', 'false');

        if (ctaDiv) ctaDiv.setAttribute("tabindex", '0'); 
        if (ctaAnchor) ctaAnchor.setAttribute("tabindex", '-1'); 
    })
    const container = swiper.el;
    const nextNav = container.querySelector('.swiper-button-next');
    const prevNav = container.querySelector('.swiper-button-prev');

    // Prev arrow
    if (prevNav) {
      if (swiper.realIndex === 0) {
        // First slide → disable prev
        prevNav.setAttribute('tabindex', '-1');
        prevNav.setAttribute('aria-hidden', 'true');
        prevNav.classList.add('swiper-button-disabled');
      } else {
        // Middle slides → enable prev
        prevNav.setAttribute('tabindex', '0');
        prevNav.setAttribute('aria-hidden', 'false');
        prevNav.classList.remove('swiper-button-disabled');
      }
    }

    // Next arrow
    if (nextNav) {
      if (swiper.realIndex === swiper.slides.length - 1) {
        // Last slide → disable next
        nextNav.setAttribute('tabindex', '-1');
        nextNav.setAttribute('aria-hidden', 'true');
        nextNav.classList.add('swiper-button-disabled');
      } else {
        // Middle slides → enable next
        nextNav.setAttribute('tabindex', '0');
        nextNav.setAttribute('aria-hidden', 'false');
        nextNav.classList.remove('swiper-button-disabled');
      }
    }
  };

  const handleKeydown = e =>{
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      e.target.click();
    }
  }
    
  return (
    <div 
    className={`responsive-carousel-container ${lbConatiner}`} 
    id={`responsive-carousel-${carouselSpecs.carouselOccurence}`}
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
    onTouchStart={handleTouchStart}
    onTouchEnd={handleTouchEnd}
    >
      {/* Carousel Swiper Container */}
     <Swiper
          ref={swiperContainerRef}
          onSwiper={(swiper) => {swiperRef.current = swiper;}}
          className={` ${"swiper-"+carouselSpecs.carouselHeight.toLowerCase()} ${chooseStyle().root}`}  
          pagination={{clickable: true}}
          keyboard={{enabled:true}}
          spaceBetween={0}
          navigation={carouselProps.indicators.enabled} // nav arrow
          loop={false} //cycle
          enabled={carouselProps.indicators.enabled} // navs visibility
          autoplay={carouselProps.autoPlay && {
            delay: carouselProps.loopInterval, //loop interval
            // pauseOnMouseEnter: true,
            disableOnInteraction: false
          }}
          effect={carouselProps.animation}
          fadeEffect={animationEffects.fadeEffect}
          speed={carouselProps.animationTimeout} //animation timeout
          onAfterInit={(swiper) => {
            updateSlidesTabIndex(swiper);
            const container = swiper.el;
            // moved swiper-wrapper above prevNav for order management
            const swiperWrapper = container.querySelector('.swiper-wrapper');
            const swiperButtonPrev = container.querySelector('.swiper-button-prev');
            container.insertBefore(swiperWrapper, swiperButtonPrev);

            //keyboard navigation
            container.querySelectorAll('.swiper-button-next, .swiper-button-prev').forEach(button => {
              button.addEventListener('keydown', handleKeydown);
            });
            
            const nextNav = container.querySelector(".swiper-button-next");
            const prevNav = container.querySelector(".swiper-button-prev");

            if (nextNav) {
              nextNav.setAttribute("aria-label", "Move to next slide");
              nextNav.setAttribute("role", "button");
            }
            if (prevNav) {
              prevNav.setAttribute("aria-label", "Move to previous slide");
              prevNav.setAttribute("role", "button");
            }
            setTimeout(() => {

              const paginationEl = container.querySelector('.swiper-pagination');
              const playBtn = playButton.current;
              const pauseBtn = pauseButton.current;
            
              if (paginationEl && playBtn && pauseBtn) {
                paginationEl.appendChild(pauseBtn);
                paginationEl.appendChild(playBtn);
              }
              const paginationDots = container.querySelectorAll(".swiper-pagination-bullet");
              paginationDots && paginationDots.length && paginationDots.forEach((dot, i) => {
                dot.setAttribute("role", "button");
                dot.setAttribute("tabindex", '0');
          
                if (dot.classList.contains("swiper-pagination-bullet-active")) {
                  dot.setAttribute("aria-label", `Slide ${i + 1}`);
                } else {
                  dot.setAttribute("aria-label", `Go to slide ${i + 1}`);
                }
                //keyboard navigation
                dot.addEventListener('keydown', handleKeydown);
              });
            }, 100);
          }}
          onSlideChange={(swiper) => {
            updateSlidesTabIndex(swiper);
            const container = swiper.el;
            const nextNav = container.querySelector(".swiper-button-next");
            const prevNav = container.querySelector(".swiper-button-prev");
            const paginationDots = container.querySelectorAll(".swiper-pagination-bullet");

            prevNav && prevNav.setAttribute("aria-label", "Move to previous slide");
            nextNav && nextNav.setAttribute("aria-label", "Move to next slide");
            nextNav && nextNav.setAttribute("role", "button");
            prevNav && prevNav.setAttribute("role", "button");
            
            paginationDots && paginationDots.length && paginationDots.forEach((dot, i) => {
              dot.setAttribute("role", "button");
              dot.setAttribute('tabindex', '0');
              const isActive = dot.classList.contains("swiper-pagination-bullet-active");
              if (isActive) {
                dot.setAttribute("aria-label", `Slide ${i + 1}`);
              } else {
                dot.setAttribute("aria-label", `Go to slide ${i + 1}`);
              }
            });
          }}
          onLoopFix={(swiper) => {
            updateSlidesTabIndex(swiper);
          }}
          onUpdate={(swiper)=>{
            updateSlidesTabIndex(swiper);
          }}
        >    
        {
          slides.map((slideContent, i) => {
              return <SwiperSlide className={`responsive-carousel`} key={i}>
                  <CarouselSlide isTimer={isCDT} slidedata={slideContent} heightClass={carouselSpecs.carouselHeight} isForeground={slideContent.foregroundImage!==undefined} onRemoveCDT={(e) => handleRemoveCDT(e)}/>
                </SwiperSlide>
              }
            )
        }
      </Swiper>
      {slides && slides.length > 1 && (
        <div>
          <button 
            ref={pauseButton} 
            className='pause-button'
            aria-label="Pause" 
            onClick={playPauseToggle}
            onKeyDown={handleKeyPress}
            tabIndex={0}
            >
              <span className="icon pause" aria-hidden="true" style={{'--pseudo-active-color': carouselProps.indicators.pagination.pseudoActive.background}} />
          </button>
          <button 
            ref={playButton} 
            aria-label="Play" 
            aria-pressed="false" 
            className='play-button'  
            onClick={playPauseToggle} 
            onKeyDown={handleKeyPress}
            style={{ display: 'none' }}
            tabIndex={-1}
            >
              <span className="icon" aria-hidden="true" style={{'--pseudo-active-color': carouselProps.indicators.pagination.pseudoActive.background}}/>
          </button>
          </div>
    )}
          {/* Carousel Curve */}
      {carouselSpecs.curveRequiredIn!="none" && <BackgroundImageCurve curveCondition={carouselSpecs.curveRequiredIn } sources={carouselSpecs.curveImage}/>}
    </div >
  );
}
export default EirResponsiveCarousel;